import apiClient from "../../../api/axios";

const BASE = "/v1/settlement/ap/workbench";

const apInvoicePipelineApi = {
    startPipeline: async (idsId, extraPrompt) => {
        const payload = { ids_id: idsId };
        if (extraPrompt) {
            payload.extra_prompt = extraPrompt;
        }
        const response = await apiClient.post(`${BASE}/pipeline/start`, payload);
        return response.data;
    },

    retryFromStage: async (idsId, stageId, extraPrompt, highResolutionPdfOcr, pdfRenderDpi) => {
        const payload = {
            ids_id: idsId,
            stage_id: stageId,
        };
        if (extraPrompt) {
            payload.extra_prompt = extraPrompt;
        }
        if (highResolutionPdfOcr !== undefined) {
            payload.high_resolution_pdf_ocr = highResolutionPdfOcr;
        }
        if (pdfRenderDpi !== undefined) {
            payload.pdf_render_dpi = pdfRenderDpi;
        }
        const response = await apiClient.post(`${BASE}/pipeline/retry`, payload);
        return response.data;
    },

    batchPipelineAction: async (idsIds, action, stageId, extraPrompt) => {
        const payload = {
            ids_ids: idsIds,
            action,
            stage_id: stageId,
        };
        if (extraPrompt) {
            payload.extra_prompt = extraPrompt;
        }
        const response = await apiClient.post(`${BASE}/pipeline/batch`, payload);
        return response.data;
    },

    stopPipeline: async (idsId) => {
        const response = await apiClient.post(`${BASE}/pipeline/stop`, {
            ids_id: idsId,
        });
        return response.data;
    },

    triggerBatchValidation: async (batchNumber, vendorId, standardCostType) => {
        const response = await apiClient.post(`${BASE}/pipeline/batch-validation`, {
            batch_number: batchNumber,
            vendor_id: vendorId,
            standard_cost_type: standardCostType,
        });
        return response.data;
    },
};

export default apInvoicePipelineApi;
